<template>
  <!-- 收款账户 -->
  <div class="Collection">
    <div class="Collection-content">
      <div class="Collection-top">
        <h1 v-if="supplierType == 0">公司收款账户</h1>
        <h1 v-else-if="supplierType == 1">个人收款账户</h1>
        <a style="padding-top: 3px;text-decoration: underline;font-size: 12px;" @click="collectionTypeShow = true">收款条件维护</a>
      </div>

      <div class="Collection-main">
        <el-form class="Form-style" v-if="supplierType == 0">
          <el-form-item class="Company-name" label="纳税人类型">
            <el-select v-model="dataForm.taxpayer" placeholder="请选择纳税人类型">
              <el-option v-for="item in taxpayerOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="Company-name" label="公司税号">
            <el-input v-model="dataForm.duty" placeholder="请输入公司税号"></el-input>
          </el-form-item>

          <el-form-item class="Company-name" label="账户名称">
            <el-input v-model="dataForm.accName" placeholder="请输入账户名称"></el-input>
          </el-form-item>

          <el-form-item class="Company-name" label="开户行">
            <el-input v-model="dataForm.bankDeposit" placeholder="点击输入开户行"></el-input>
          </el-form-item>

          <el-form-item class="Company-name" label="账号">
            <el-input v-model="dataForm.cardNo" placeholder="点击输入账号"></el-input>
          </el-form-item>

          <el-form-item class="Company-name" label="财务联系人姓名">
            <el-input v-model="dataForm.financeName" placeholder="点击输入姓名"></el-input>
          </el-form-item>

          <el-form-item class="Company-name" label="财务联系方式">
            <el-input v-model="dataForm.financePhone" placeholder="点击输入手机号码"></el-input>
          </el-form-item>

          <el-form-item class="Company-name" label="收款条件">
            <span v-if="dataForm.collection === 3">{{dataForm.remark}}</span>
            <span v-else>{{collectionText[dataForm.collection]}}</span>
          </el-form-item>

          <el-form-item class="Company-name Last-hang" label="企业收款二维码">
            <wintac-upload imgName="企业收款二维码" :pid="dataForm.supplierId" :state="1" env="user">
            </wintac-upload>
          </el-form-item>
        </el-form>

        <el-form class="Form-style" v-else-if="supplierType == 1">
          <el-form-item class="Company-name" label="账户名称">
            <el-input v-model="dataForm.accName" placeholder="点击输入账户名称"></el-input>
          </el-form-item>

          <el-form-item class="Company-name" label="开户行">
            <el-input v-model="dataForm.bankDeposit" placeholder="点击输入开户行"></el-input>
          </el-form-item>

          <el-form-item class="Company-name" label="账号">
            <el-input v-model="dataForm.cardNo" placeholder="点击输入账号"></el-input>
          </el-form-item>

          <el-form-item class="Company-name Last-hang" label="个人收款二维码">
            <wintac-upload imgName="个人收款二维码" :state="1" :pid="dataForm.supplierId" env="user">
            </wintac-upload>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-dialog class="productTypeDialog" title="提示" custom-class="customProduct" :visible.sync="collectionTypeShow" width="40%">
      <div class="dialog-top">
        <span>收款条件维护</span>
      </div>
      <div class="product-checkBox">
        <el-radio-group v-model="dataForm.collection">
          <el-radio :label="0">发送回确认时提供支付信息,支付全款</el-radio>
          <el-radio :label="1">使用日期前支付全款</el-radio>
          <el-radio :label="2">账期为使用日期后一个月</el-radio>
          <el-radio :label="3">其它</el-radio>
        </el-radio-group>
        <el-input v-if="dataForm.collection === 3" type="textarea" :rows="3" style="width: 80%;" v-model="dataForm.remark" placeholder="点击此处输入付款政策"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="collectionTypeShow = false">取 消</el-button>
        <el-button type="primary" @click="collectionTypeShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  import SupplierInfoProps from '../Child/SupplierInfoProps'
  import { mapState } from 'vuex'
  export default {
    name: '',
    components: {

    },
    props: SupplierInfoProps,
    // 定义属性
    data() {
      return {
        collectionTypeShow: false,
        collectionRadio: 0,
        dataForm: {
          id: '',
          taxpayer: 0, //0 一般纳税人 1 小规模纳税人
          duty: '', //公司税号
          accName: '', //账户名称
          bankDeposit: '', //开户行
          cardNo: '', //卡号
          financeName: '', //财务联系人姓名
          financePhone: '', //财务手机号码
          collection: '', //0 发送回确认时提供支付信息，支付全款  1 使用日期前支付全款 2 账期为使用日期后一个月 3其他
          remark: '', //collection = 3 时所填写的描述信息
          supplierType: this.supplierType, //0 机构供应商  1 个人供应商 （查导游资源表）
        },
        taxpayerOptions: [
        {
          value: 0,
          label: '一般纳税人'
        },
        {
          value: 1,
          label: '小规模纳税人'
        }],
        collectionText: {
          '0': '发送回确认时提供支付信息，支付全款',
          '1': '使用日期前支付全款',
          '2': '账期为使用日期后一个月'
        }
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapState(['supplierBasics'])
    },
    // 监控data中的数据变化
    watch: {
      'dataForm': {
        handler(value) {
          this.$store.commit('setCollectionList', value)
        },
        deep: true
      },
      'tianyanchaQueryData': {
        handler(value) {
          this.dataForm.duty = value.taxpayerNumber
        },
        deep: true
      },
      'supplierBasics': {
        handler(value) {
          if (value.collectionList.length > 0) {
            this.dataForm = value.collectionList[0]
          }
        },
      }
    },
    // 方法集合
    methods: {
      enterpriseFileList(e, type) {
        this.dataForm.fileList = e
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style scoped lang="scss">
  .Collection {
    //width: 12.8rem;
    margin: 0 auto;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.11);
    border-radius: 6px 6px 6px 6px;
    background-color: rgba(255, 255, 255, 1);
    margin: 15px auto;

    .Collection-content {
      padding: 30px;
    }

    .Collection-top {
      display: flex;
      justify-content: space-between;

      >a:hover {
        cursor: pointer;
      }
    }

    .Form-style {
      padding-top: 15px;
    }

    .Form-style /deep/.el-input__inner {
      border: none;
      background: none;
      border-radius: 0 !important;
      padding-left: 0;
      font-size: 14px;
      font-family: PingFangSC-light;
    }

    .Form-style /deep/.el-form-item__label {
      font-size: 14px;
      border-radius: 0 !important;
      padding-right: 150px;
      font-family: PingFangSC-light;
      width: 5rem;
      text-align: left;
    }

    .Form-style /deep/.el-form-item {
      display: flex;
      border-bottom: 1.3px dashed rgba(242, 237, 237, 1);
    }
  }

  .Last-hang {
    border-bottom: none !important;
  }

  .productTypeDialog /deep/.el-dialog__header {
    display: none;
  }

  .productTypeDialog /deep/.dialog-top {
    width: 100%;
    background: var(--color);
    color: white;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    border-radius: 0.2rem 0.2rem 0 0;
    font-size: 14px;
  }

  .productTypeDialog /deep/.el-dialog__body {
    padding: 0;
  }

  .productTypeDialog /deep/.el-checkbox {
    width: 0.7rem;
    line-height: 2;
  }

  .productTypeDialog /deep/.product-checkBox {
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    .el-radio-group {
      display: flex;
      flex-direction: column;

      .el-radio {
        margin-bottom: 10px;
      }
    }
  }
</style>